/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_speed_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is a nautical mile longer than a regular mile?`)
};

const es_uc_speed_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Una milla náutica es más larga que una milla regular?`)
};

const de_uc_speed_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist eine Seemeile länger als eine gewöhnliche Meile?`)
};

const nl_uc_speed_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een zeemijl langer dan een normale mijl?`)
};

const fr_uc_speed_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un mille nautique est-il plus long qu'un mile régulier ?`)
};

const it_uc_speed_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un miglio nautico è più lungo di un miglio normale?`)
};

const pt_br2_uc_speed_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma milha náutica é mais longa que uma milha comum?`)
};

const pt_uc_speed_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma milha náutica é mais longa do que uma milha regular?`)
};

const ja_uc_speed_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`海里は通常のマイルより長いですか?`)
};

const zh_uc_speed_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_speed_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_speed_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_speed_faq3_q", locale)
	if (locale === "en") return en_uc_speed_faq3_q(inputs)
	if (locale === "es") return es_uc_speed_faq3_q(inputs)
	if (locale === "de") return de_uc_speed_faq3_q(inputs)
	if (locale === "nl") return nl_uc_speed_faq3_q(inputs)
	if (locale === "fr") return fr_uc_speed_faq3_q(inputs)
	if (locale === "it") return it_uc_speed_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_speed_faq3_q(inputs)
	if (locale === "pt") return pt_uc_speed_faq3_q(inputs)
	if (locale === "ja") return ja_uc_speed_faq3_q(inputs)
	return zh_uc_speed_faq3_q(inputs)
};